// exclude-from-index
import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@mui/material/MenuItem';
import { filterTypeShape } from '../lib/ListComponent.shapes';
import { SortContainer, StyledSelect, StyledMenuText, StyledArrow, StyledParagraph } from './FilterToggle.styles';

function FilterToggle(props) {
  const {
    currentFilter,
    filterType: { onChange, handleDropdownClose, defaultFilter, openConst, filterCollection, handleDropdownOpen },
    label,
    open
  } = props;

  return (
    <SortContainer>
      <StyledSelect value={currentFilter.label} open={open} onChange={onChange} onClose={handleDropdownClose}>
        {filterCollection.length ? (
          filterCollection.map((filter) => (
            <MenuItem key={filter.label} value={filter}>
              <StyledMenuText>{filter.label}</StyledMenuText>
            </MenuItem>
          ))
        ) : (
          <MenuItem key={defaultFilter.label} value={defaultFilter}>
            <StyledMenuText>{defaultFilter.label}</StyledMenuText>
          </MenuItem>
        )}
      </StyledSelect>

      <button type="button" onClick={() => handleDropdownOpen(openConst)}>
        <StyledParagraph tagName="p" noMargins>
          {label}:
          <StyledParagraph weight="bold" tagName="span" noMargins>
            {currentFilter.label}
          </StyledParagraph>
        </StyledParagraph>
        <StyledArrow />
      </button>
    </SortContainer>
  );
}

FilterToggle.propTypes = {
  filterType: filterTypeShape.isRequired,
  label: PropTypes.string,
  open: PropTypes.bool,
  currentFilter: PropTypes.oneOfType([
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      sortFn: PropTypes.func
    }),
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      viewFn: PropTypes.func
    })
  ]).isRequired
};

FilterToggle.defaultProps = {
  open: false,
  label: 'Filter'
};

export default FilterToggle;
